"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headline = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Headline_styled_1 = require("./Headline.styled");
const Headline_types_1 = require("./Headline.types");
function Headline({ headlineStyle = Headline_types_1.HeadlineStyle.Medium, align = Headline_types_1.HeadlineAlign.Left, color = Headline_types_1.HeadlineColor.DigitalBlack, as, children, dataTestId }) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    let StyledTagHeadline = as;
    const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'];
    switch (headlineStyle) {
        case 'hero':
            StyledTagHeadline = 'h2';
            break;
        case 'huge':
            StyledTagHeadline = 'h3';
            break;
        case 'big':
            StyledTagHeadline = 'h4';
            break;
        case 'large':
            StyledTagHeadline = 'h5';
            break;
        case 'medium-large':
            StyledTagHeadline = 'h6';
            break;
        case 'medium':
            StyledTagHeadline = 'p';
            break;
        default:
            StyledTagHeadline = 'h1';
            break;
    }
    if (as && allowedTags.includes(`${as}`)) {
        StyledTagHeadline = as;
    }
    return (react_1.default.createElement(Headline_styled_1.StyledHeadline, { "data-testid": dataTestId, as: StyledTagHeadline, headlineStyle: headlineStyle, align: align, color: color, theme: theme }, children));
}
exports.Headline = Headline;
//# sourceMappingURL=Headline.js.map